import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { Cin7Sale } from "@/api/dtos";
import type { Sale } from "./_models/Sale";
import { toSaleFromCin7Sale } from "./_transformers/toSaleFromCin7Sale";

/** One Cin7 sale by ID (via the backend Cin7 proxy). */
export const getSaleByIdApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSaleById: builder.query<Sale, string>({
      queryFn: async (id) => {
        try {
          const res = await axios.get<Cin7Sale>(
            `${backendBase()}/cin7/sale`,
            {
              params: { ID: id },
              headers: { Accept: "application/json" },
            },
          );
          const sale = toSaleFromCin7Sale(res.data);
          return { data: sale };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getSaleById = getSaleByIdApi.endpoints.getSaleById;
